<template>
  <div>
    <a-spin :spinning="newsSpinning">
      <div class="info-content">
        <div class="topTitle">
          <div class="title">学籍确认信息</div>
          <div class="time">学籍科电话：0371-61912178 （工作时间）</div>
        </div>
        <div>
          <div
            class="label_out"
            v-for="(item, index) in list"
            :key="item.name"
            style="margin-bottom: 5px"
            :style="item.type == 1 ? 'background: #DEF0DE;' : item.type == 2 ? 'background: #FCE6E7;' : ''"
          >
            <div class="left">{{ item.label }}</div>
            <div class="right">
              <p>{{ item.value }}</p>
              <div v-if="item.name == 'idNo' || item.name == 'birthday' || item.name == 'nation' || item.name == 'political'" style="display: flex">
                <div class="right_tab" @click="on(1, index, item)">
                  <div class="on" v-if="item.type == 1" style="background: #3eb03f">
                    <img src="../image/right_2.png" style="width: 12px; height: 9px" />
                  </div>
                  <img src="../image/right_1.png" v-else />
                  确认无误
                </div>
                <div class="wrong_tab" @click="on(2, index, item)">
                  <div class="on" v-if="item.type == 2" style="background: #e95356">
                    <img src="../image/wrong_2.png" style="width: 10px; height: 10px" />
                  </div>
                  <img src="../image/wrong_1.png" v-else />
                  信息有误
                </div>
              </div>
              <div class="wrong_message" v-if="item.type == 2">
                <a-radio-group v-model="item.message" v-if="item.name == 'sex'">
                  <a-radio :value="'男'">男</a-radio>
                  <a-radio :value="'女'">女</a-radio>
                </a-radio-group>
                <a-date-picker
                  v-model="item.message"
                  v-else-if="item.name == 'birthday'"
                  :placeholder="'请选择正确的' + item.label"
                  style="width: 200px"
                  value-format="YYYY-MM-DD"
                  :defaultValue="item.message"
                  :defaultPickerValue="item.message"
                />
                <!-- <j-dict-select-tag
                  v-else-if="item.name == 'nation'"
                  type="select"
                  v-model="item.message"
                  dictCode="nation"
                  placeholder="请选择"
                  style="width: 200px"
                /> -->

                <a-select
                  @focus="focusChange('nation')"
                  allowClear
                  showSearch
                  v-model="item.message"
                  placeholder="请选择正确的民族"
                  v-else-if="item.name == 'nation'"
                  style="width: 200px"
                >
                  <a-select-option v-for="(item, index) in nationList" :key="index" :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
                <a-select
                  v-else-if="item.name == 'political'"
                  v-model="item.message"
                  allowClear
                  showSearch
                  @focus="focusChange('political')"
                  placeholder="请选择正确的政治面貌"
                  style="width: 200px"
                >
                  <a-select-option v-for="(item, index) in politicalList" :key="index" :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
                <a-input v-else :placeholder="'请输入正确的' + item.label" v-model="item.message" style="width: 200px" />
              </div>
            </div>
          </div>
        </div>
        <div class="label_out">
          <div class="left">邮箱</div>
          <a-input placeholder="请输入邮箱" v-model="email" class="right" style="flex: 1" />
        </div>
        <div class="label_out">
          <div class="left">联系地址</div>
          <a-input placeholder="请输入联系地址" v-model="address" class="right" style="flex: 1" />
        </div>
      </div>
      <a-form-item :wrapper-col="{ span: 12, offset: 9 }">
        <a-button type="primary" class="submit-btn" @click="exit">
          退出登录
        </a-button>
        <a-button type="primary" html-type="submit" class="submit-btn" :loading="submitLoading" @click="handleSubmit">
          确认信息
        </a-button>
      </a-form-item>
    </a-spin>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import Alphabet from '../../city/components/Alphabet';
import { mapState } from 'vuex';
export default {
  name: 'infoRecheck',
  components: {
    Alphabet,
  },
  data: function() {
    return {
      newsSpinning: false,
      submitLoading: false,
      nationList: [], //民族列表
      politicalList: [], //政治面貌列表
      isRight: -1,
      list: [],
      address: '',
      email: '',
    };
  },
  created() {},
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    on(type, index, item) {
      if (type == 1 && !item.value) {
        this.$message.error('请选择信息有误，并补充正确信息');
        return;
      }
      this.$set(this.list[index], 'type', type);
    },
    focusChange(code) {
      this.getNation(code);
    },

    getNation(code) {
      this.axios.get(`/sys/dict/getDictItems/${code}`).then(res => {
        if (code == 'nation') {
          this.nationList = res.result;
        } else if (code == 'political') {
          this.politicalList = res.result;
        } else if (code == 'archive_feedback_field') {
          this.typeList = res.result;
        }
      });
    },

    handleCancel() {
      this.visible = false;
    },
    handleInfoFeed() {
      this.visible = true;
    },

    exit() {
      this.axios.get(`sys/logout`).then(res => {
        if (res.success) {
          this.$message.success(res.result, 1);
        }
        localStorage.clear();
        setTimeout(() => {
          this.common.toURL(`/login?id=${this.userInfo.eduCode}`);
        }, 1000);
      });
    },
    handleFeedOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            title: this.feedbackType.join(',') || '',
            content: this.content,
            type: 1,
          };
          this.axios.post(`/biz/user/feedback`, params).then(res => {
            if (res.success) {
              // 处理反馈提交逻辑
              this.$message.success('反馈已提交');
              this.visible = false;
              this.feedbackType = null;
              this.content = '';
            } else {
              this.$message.error('反馈提交失败，请稍后再试');
            }
          });
        }
      });
    },
    handleSubmit() {
      if (this.list.some(item => item.type == -1)) {
        this.$message.warning('请确认所有信息后再提交');
        return;
      }
      if (this.list.some(item => item.type == 2 && item.message == '')) {
        this.$message.warning('请填写正确的信息');
        return;
      }
      let data = JSON.parse(JSON.stringify(this.list));
      if (this.list[8].type == 2) {
        if (this.strictValidateIDCard(this.list[8].message) == false) {
          this.$message.warning('请输入正确的身份证号码');
          return;
        }
      }
      if (this.email) {
        if (this.validateEmail(this.email) == false) {
          this.$message.warning('请输入正确的邮箱格式');
          return;
        }
      }
      data.push({
        name: 'email',
        message: this.email,
        type: 3,
      });
      data.push({
        name: 'address',
        message: this.address,
        type: 3,
      });
      this.axios.post(`/biz/user/stuConfirm`, data).then(res => {
        if (res.success) {
          this.$message.success('操作成功');
          this.$emit('refeshModalShow');
        }
      });
    },
    strictValidateIDCard(id) {
      const pattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/;
      return pattern.test(id);
    },
    validateEmail(email) {
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return pattern.test(email);
    },
  },
  mounted() {
    this.address = this.userInfo.address;
    this.email = this.userInfo.email;
    this.list = [
      {
        value: this.userInfo.eduName,
        type: 3,
        name: 'eduName',
        label: '学校',
      },
      {
        value: this.userInfo.name,
        type: 3,
        name: 'name',
        label: '姓名',
        message: '',
      },
      {
        value: this.userInfo.sex == 1 ? '男' : '女',
        type: 3,
        name: 'sex',
        label: '性别',
        message: this.userInfo.sex == 1 ? '男' : '女',
      },
      {
        value: this.userInfo.studentNo,
        type: 3,
        name: 'studentNo',
        label: '学号',
        message: '',
      },
      {
        value: this.userInfo.proName,
        type: 3,
        name: 'proName',
        label: '专业',
        message: '',
      },
      {
        value: this.userInfo.proSystem,
        type: 3,
        name: 'proSystem',
        label: '学制',
        message: '',
      },
      {
        value: this.userInfo.learnLevel,
        type: 3,
        name: 'learnLevel',
        label: '学习层次',
        message: '',
      },
      {
        value: this.userInfo.siteName,
        type: 3,
        name: 'siteName',
        label: '所属教学点',
        message: '',
      },
      {
        value: this.userInfo.idNo,
        type: -1,
        name: 'idNo',
        label: '身份证号',
        message: '',
      },
      {
        value: this.userInfo.birthday,
        type: -1,
        name: 'birthday',
        label: '出生日期',
        message: '',
      },
      {
        value: this.userInfo.nation,
        type: -1,
        name: 'nation',
        label: '民族',
        message: undefined,
      },
      {
        value: this.userInfo.political,
        type: -1,
        name: 'political',
        label: '政治面貌',
        message: undefined,
      },
    ];
    if (this.userInfo.idNo) {
      this.list[9].message = `${this.userInfo.idNo.substring(6, 10)}-${this.userInfo.idNo.substring(10, 12)}-${this.userInfo.idNo.substring(12, 14)}`;
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
.label_out{
  display: flex;
  align-items: center;
  padding 0 20px
  height: 40px;
  border-radius 4px
}
.left {
  padding-right: 0;
  text-align-last: justify;
  width: 70px;
  color: #9A9A9A;
  font-size 14px;
}
.right {
  flex: 1;
  margin-left: 20px;
  display: flex;
  align-items: center;
  p {
    width: 200px;
    color: #333333;
    font-size 14px;
  }
}
.info-content {
  padding: 10px 0;
  background: #fff;
  .topTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding 0 20px
    .title {
      font-size: 18px;
      font-weight: bold;
    }
    .time {
      color: #999;
      font-size: 14px;
    }
  }
}
.submit-btn {
  width: 120px;
  height: 36px;
  line-height: 36px;
  padding: 0;
  margin-top: 30px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 4px;
  margin-right: 30px;
}
</style>
<style lang="scss" scoped>
.right_tab {
  display: flex;
  font-weight: bold;
  font-size: 14px;
  color: #3eb03f;
  text-decoration-line: underline;
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.wrong_tab {
  display: flex;
  font-weight: bold;
  font-size: 14px;
  color: #e95356;
  text-decoration-line: underline;
  cursor: pointer;
  margin-left: 30px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.on {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-right: 0;
  }
}
.wrong_message {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/infoRecheck.vue